const theme = {
  colors: {
    primary: "#40E0D0",
    secondary: "#9333EA",
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#DC2626",
    trnasparent: "#0C0A1D0D",
    bgColor: "#0C0A1D",
    background: {
      main: "rgb(64, 224, 208, 0.05 )",
      secondary:
        "linear-gradient(90deg, rgb(64, 224, 208) 0%, rgb(32, 95, 156) 100%)",
      paper: "#1A2032",
    },

    text: {
      primary: "#FFFFFF",
      secondary: "rgba(255, 255, 255, 0.8)",
      tertiary: "rgba(255, 255, 255, 0.6)",
      quaternary: "rgba(255, 255, 255, 0.05)",
      quinary: "rgba(255, 255, 255, 0.2)",
      disabled: "#FFFFFF",
    },

    border: "#2B3343",

    gradient: {
      // themeGradient:
      //   "linear-gradient(90deg, rgb(64, 224, 208) 0%, rgb(32, 95, 156) 100%) text",
      themeGradient: "linear-gradient(90deg, #40E0D0 10%, #205F9C 100%)",
      backgroundGradient:
        "linear-gradient(180deg, #0C0A1D 0%, rgba(64, 224, 208, 0.05) 100%)",
    },
  },
};

export default theme;
